<template>
  <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
    <v-form v-bind="this.$attrs">
      <v-row>
        <SelectEntity
          :initValue="info.productIndustry"
          @change="v => (info.productIndustry = v)"
          entity="industries"
          label="Ngành hàng"
        />
        <SelectEntity
          :initValue="info.producer"
          @change="v => (info.producer = v)"
          class="ml-2"
          entity="producers"
          label="Nhà sản xuất"
        />
        <SelectEntity @change="v => (info.productType = v)" class="ml-2" entity="productTypes" label="Chủng hàng" />
      </v-row>
      <v-row>
        <SelectDate
          @change="dateChange"
          :isShowLabel="false"
          :hideDetails="true"
          class="mb-4 mr-3 mt"
          placeholder="Chọn ngày"
          :rules="[$rules.date]"
        ></SelectDate>
      </v-row>
    </v-form>
    <div class="d-flex flex-wrap justify-end mt-8 flex-gap">
      <v-btn class="ml-6" dark depressed color="#0D47A1" @click="filter">
        <v-icon left>mdi-filter</v-icon>Áp dụng</v-btn
      >
    </div>
  </v-card>
</template>
<script>
import SelectEntity from '@/components/samnec/SelectEntity.vue'
import SelectDate from '@/components/samnec/SelectDate.vue'
import { omitBy } from 'lodash'
import { mapMutations } from 'vuex'
const moment = require('moment')
export default {
  components: { SelectEntity, SelectDate },
  data() {
    return {
      info: {
        date: null,
        productIndustry: null,
        producer: null,
        productType: null
      },
      value: ''
    }
  },
  async mounted() {
    this.info.producer = this.$route.query.producer
    this.info.productIndustry = this.$route.query.productIndustry
    if (this.info.producer) this.value = `Hôm nay (${moment(this.info.end).format('DD/MM/YYYY')})`
    else this.value = 'Chọn khoảng thời gian'
    setTimeout(async () => {
      await this.filter()
      this.dateChange(this.info)
    }, 1000)
  },
  methods: {
    ...mapMutations({
      setQuerySearch: 'reportOnTimes/setQuerySearch'
    }),
    dateChange(date) {
      this.info.date = date
    },
    async filter() {
      const payload = omitBy(this.info, v => v == null)
      this.setQuerySearch(payload)
      this.$emit('onFilter', payload)
    }
  }
}
</script>
